import { PersistedOrder } from '@features/orders/persisted-order';
import { isPresent, slice } from '@imcc/utilities';
import { buildOrderAssetProduct } from './build-order-asset-product';
import { EcommerceEvent } from './ecommerce-event-enum';
import { IOrderDownload } from './i-order-download';

export function buildOrderDownload(order: PersistedOrder): IOrderDownload {
  const firstAsset = order.assets[0] || { parameters: {} };
  let format: string | undefined;

  if (isPresent(firstAsset.parameters)) {
    format = firstAsset.parameters.fm;
  }

  return {
    event: EcommerceEvent.Purchase,
    ecommerce: {
      purchase: {
        actionField: { id: order.orderId, revenue: '0' },
        dimension10: order.flow,
        dimension11: format || 'N/A',
        dimension12: order.unit,
        products: order.assets.map(buildOrderAssetProduct),
      },
    },
    otherData: slice(
      order,
      'completedAt',
      'createdAt',
      'lastModifiedAt',
      'processStartedAt',
      'size',
    ),
  };
}
